import { HttpErrorResponse } from '@angular/common/http';
import {Injectable} from '@angular/core';
import {NotificationService} from "./notification.service";

export enum RequestTypesEnum {
  LOGIN = 'LOGIN',
  REGISTRAZIONE = 'REGISTRAZIONE',
  ERRORE_GENERICO = 'ERRORE_GENERICO',
  DELETE_PROFILE = 'DELETE_PROFILE',
  UPDATE_PROFILE = 'UPDATE_PROFILE',
  UPDATE_PASSWORD = 'UPDATE_PASSWORD',
  GET_PROFILE = 'GET_PROFILE',
  ERRORE_RECUPERA_PASSWORD = 'ERRORE_RECUPERA_PASSWORD',
  TIMEOUT = 'TimeoutError',
  OFFLINE = 'OFFLINE',
  GET_FIGLI = 'GET_FIGLI',
  GET_MENU = 'GET_MENU',
  GET_RICARICHE = 'GET_RICARICHE',
  GET_CALENDARIO = 'GET_CALENDARIO',
  ERRORE_AGGIUNTA_EVENTO = 'ERRORE_AGGIUNTA_EVENTO',
  ERRORE_AGGIUNTA_EVENTO_CAUSA_ORARIO = 'ERRORE_AGGIUNTA_EVENTO_CAUSA_ORARIO',
  TOKEN = 'TOKEN',
  POST_RICARICA= 'POST_RICARICA',
  DELETE_RICARICA = 'DELETE_RICARICA',
  RICARICA = 'RICARICA',
  GET_PRATICHE = 'GET_PRATICHE',
  INVIO_ASSISTENZA = 'INVIO_ASSISTENZA',
}


@Injectable({
  providedIn: 'root'
})
export class ManageErrorService {

  constructor(private notificationService: NotificationService) {
  }

  manageError(error: HttpErrorResponse, requestType: RequestTypesEnum) {
    let httpStatus: number = error.status;
    let errorCode: number = !!error.error ? error.error.code : null;
    let errorMessage: string = !!error.error ? error.error.message : null;
    let errorType: string = !!error.error ? error.error.error : null
    let messageToShow: string;
    messageToShow = this.getErrorMessage(requestType, httpStatus, errorCode, errorMessage, errorType);
    this.notificationService.openToast({message: messageToShow, color: 'danger'})
  }

  getErrorMessage(requestType: RequestTypesEnum, httpStatus: number, errorCode: number, errorMessage: string, errorType?: string): string {
    let defaultMessage = 'Si è verificato un errore. Riprovare più tardi o contattare l\'assistenza.';
    let defaultLogInMessage = 'Si è verificato un errore durante la richiesta di log in, si prega di riprovare.';
    let message;
    if (errorCode === 1500 && !!(errorMessage || '').trim()) {
      return errorMessage;
    }
    switch (requestType) {

      case (RequestTypesEnum.LOGIN):
        if (!!httpStatus) {
          switch (httpStatus) {

            case (401):
              return message = !!errorType && (errorType === 'invalid_grant') ? 'Le credenziali inserite non sono corrette, si prega di riprovare.' : defaultLogInMessage;

            default:
              return defaultLogInMessage;
          }
        } else
          return defaultLogInMessage;

      case (RequestTypesEnum.REGISTRAZIONE):
        if (!!httpStatus) {
          switch (httpStatus) {
            case (500):
              switch (errorCode) {
                case(410):
                  return message = 'L\'email inserita risulta già in uso, si prega di usare una mail diversa o di provare a recuperare la password.';
                default:
                  return defaultMessage
              }
            /*case (400):
              return message = 'L\'email inserita risulta già in uso, si prega di usare una mail diversa o di provare a recuperare la password.';
            */
            default:
              return defaultMessage;
          }
        } else
          return defaultMessage;
      case (RequestTypesEnum.UPDATE_PROFILE):
        return 'Errore durante la richiesta di modifica del profilo. Si prega di riprovare';
      case (RequestTypesEnum.DELETE_PROFILE):
        return 'Errore durante richiesta di cancellazione del profilo. Si prega di riprovare';
      case (RequestTypesEnum.GET_PROFILE):
        return 'Errore durante il recupero delle informazioni dell’utente. Si prega di riprovare';
      case (RequestTypesEnum.UPDATE_PASSWORD):
        return 'Errore durante l\'aggiornamento della password. Si prega di riprovare';
      case (RequestTypesEnum.ERRORE_RECUPERA_PASSWORD):
        switch (errorCode) {
          case(411):
            return 'Recupero password non riuscito. Verificare che l\'indirizzo email sia corretto.';
          default:
            return 'Errore nell\'invio della richiesta di recupero password. Riprovare più tardi.';
        }
      case (RequestTypesEnum.TIMEOUT):
        return 'Attenzione, connessione scarsa o assente. I dati visualizzati potrebbero non essere aggiornati.';
      case(RequestTypesEnum.GET_FIGLI):
        return 'Errore durante il recupero delle informazioni degli studenti. Si prega di riprovare';
      case(RequestTypesEnum.GET_MENU):
        return 'Errore durante il recupero delle informazioni dei menù. Si prega di riprovare';
      case(RequestTypesEnum.GET_RICARICHE):
        return 'Errore durante il recupero delle informazioni delle ricariche';
      case(RequestTypesEnum.ERRORE_AGGIUNTA_EVENTO):
        return 'Errore durante l\'aggiunta dell\'evento. Riprovare più tardi.';
      case(RequestTypesEnum.ERRORE_AGGIUNTA_EVENTO_CAUSA_ORARIO):
        return 'Si è verificato un errore durante l\'aggiunta dell\'evento. Richiesta effettuata oltre l\'ora massima consentita"';
      case(RequestTypesEnum.GET_CALENDARIO):
        return 'Errore durante il caricamento del calendario. Riprovare più tardi.';
      case( RequestTypesEnum.TOKEN):
        return 'Errore durante l\'aggiornamento della sessione, si prega di rieseguire la login. Grazie.'
      case(RequestTypesEnum.GET_PRATICHE):
        return 'Errore durante il recupero delle informazioni delle pratiche. Si prega di riprovare';
      case (RequestTypesEnum.ERRORE_GENERICO):
        return 'Errore durante il caricamento dei dati. Riprovare più tardi.';
      case RequestTypesEnum.DELETE_RICARICA:
        return 'Errore durante l\'eliminazione del pagamento. Riprovare più tardi.';
      case RequestTypesEnum.POST_RICARICA:
        return 'Errore durante la generazione del pagamento. Riprovare più tardi.';
      case RequestTypesEnum.RICARICA:
        if (errorCode === 1500 && !!(errorMessage || '').trim()) {
          return errorMessage;
        }
        return 'Errore durante l’operazione di pagamento. Si prega di riprovare.';
      case RequestTypesEnum.INVIO_ASSISTENZA:
        return 'Errore durante l\'invio del messaggio. Riprovare più tardi.';
      default:
        return defaultMessage;
    }
  }


}
